module.exports = __webpack_public_path__ + "media/images/amenities_icons/incubator_programs-0fc2cd733cf0d5864c47de90c0a6c695.svg";